import React, { useEffect } from "react";
import { Button, Card, CardBody } from "reactstrap";
import ImageUploading from "react-images-uploading";
import { useTranslation } from "react-i18next";

const maxFileSize = 5000000;

const ImageUploader = (props) => {
  const { t } = useTranslation();
  const [images, setImages] = React.useState(props.images);
  const maxNumber = props.maxNumber;

  const onChange = (imageList) => {
    setImages(imageList);
    props.onChange(imageList);
  };

  useEffect(() => {
    if (props.isEdit) setImages(props.images);
  }, [props.images]);

  return (
    <div className="App">
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        maxFileSize={maxFileSize}
        acceptType={["jpg", "jpeg", "png", "gif"]}
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageRemove,
          isDragging,
          dragProps,
          errors,
        }) => (
          <div>
            {errors && (
              <div className="mb-3">
                {errors.maxNumber && (
                  <span>
                    {t(
                      "Messages.Error.Number of selected images exceed max number of images"
                    )}
                  </span>
                )}
                {errors.acceptType && (
                  <span>
                    {t("Messages.Error.Your selected file type is not allow")}
                  </span>
                )}
                {errors.maxFileSize && (
                  <span>
                    {t(
                      "Messages.Error.Selected file size exceed maximum allowed size"
                    )}
                  </span>
                )}
                {errors.resolution && (
                  <span>
                    {t(
                      "Messages.Error.Selected file is not match your desired resolution"
                    )}
                  </span>
                )}
              </div>
            )}
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <button
                className="btn btn-success btn-sm"
                style={isDragging ? { color: "red" } : undefined}
                onClick={onImageUpload}
                {...dragProps}
              >
                <i className="ri-add-line"></i> {t("Common.Add Images")}
              </button>
              &nbsp;
              {imageList && imageList.length > 0 && (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={onImageRemoveAll}
                >
                  <i className="ri-delete-bin-line" /> {t("Common.Remove all")}
                </button>
              )}
            </div>
            {images && images.length > 0 && (
              <Card>
                <CardBody>
                  <div className="row">
                    {imageList.map((image, index) => (
                      <div key={index} className="col-md-4">
                        <img
                          className="img-thumbnail"
                          src={image.dataURL}
                          alt=""
                          style={{
                            maxHeight: 90,
                            objectFit: "contain",
                            minWidth: 130,
                            marginBottom: 10,
                          }}
                        />
                        <Button
                          style={{
                            position: "absolute",
                            right: 15,
                            backgroundColor: "none",
                            top: 4,
                            borderRadius: 50,
                            width: 20,
                            height: 20,
                            opacity: 0.9,
                            border: 0,
                          }}
                          color="danger"
                          className="btn-icon btn-xs"
                          outline
                          onClick={() => onImageRemove(index)}
                        >
                          {" "}
                          <i className="ri-delete-bin-line" />{" "}
                        </Button>
                      </div>
                    ))}
                  </div>
                </CardBody>
              </Card>
            )}
          </div>
        )}
      </ImageUploading>
    </div>
  );
};
export default ImageUploader;
